import React from 'react'
import Styles from './styles.module.sass'

export default function DisclaimerNotice(props){
    const {
        contentSecion
    } = props
    
    return (
        <div className={Styles?.disclaimerNotice}>
            {contentSecion[0]?.visible
                ?
                    <p>{contentSecion[0]?.title}</p>
                : null
            }
        </div>
    )
}